;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { deleteLocalStorageItem } from "@/lib/browser-storage/localStorage";
import { deleteSessionStorageItem } from "@/lib/browser-storage/sessionStorage";
import { createStore } from "./createStore";

export interface User {
	id: string;
	firstName?: string;
	lastName?: string;
	email?: string;
	emailVerified?: boolean;
	phone?: string | null;
	image?: string | null;
	role?: "ADMIN" | "USER";
	organizationId?: string;
}

export interface AuthState {
	user: User | null;
	isAuthenticated: boolean;
	isLoading: boolean;
}

type AuthActions = {
	setUser: (user: User | null) => void;
	setAuthenticated: (status: boolean) => void;
	setIsLoading: (isLoading: boolean) => void;
	logout: (temporary?: boolean) => Promise<void>;
	clearPersistedState: () => void;
};

export const useAuthStore = createStore<AuthState, AuthActions>({
	actions: (set) => ({
		/**
		 * Utility to clear persisted state (localStorage/sessionStorage)
		 */
		clearPersistedState: () => {
			deleteLocalStorageItem("auth-store");
			deleteSessionStorageItem("auth-store");
		},
		logout: async (temporary) => {
			await fetch("/api/logout", {
				credentials: "include",
				method: "POST",
			});

			if (temporary) {
				return set({
					isAuthenticated: false,
					isLoading: false,
				});
			}

			set({
				isAuthenticated: false,
				isLoading: false,
				user: null,
			});
		},
		setAuthenticated: (status: boolean) =>
			set({
				isAuthenticated: status,
			}),
		setIsLoading: (isLoading) => set({ isLoading }),
		setUser: (user) =>
			set({
				user,
			}),
	}),
	initialState: {
		isAuthenticated: false,
		isLoading: true,
		user: null,
	},
	name: "auth-store",
	persist: {
		enabled: true,
		// Example migration function for future schema changes
		migrate: (persistedState) => {
			// Example: if (_version < 2) { ... }
			return persistedState as AuthState;
		},
		type: "local",
		version: 1,
	},
});
